/* eslint-disable-next-line */
import Vue from 'vue';
import APIBase from './base';

export default (ctx, inject) => {
  const api = new APIBase(ctx);
  Vue.api = api;

  if (!process.env.SPA && process.env.API_PROXY) {
    if (process.browser) ctx.$axios.defaults.baseURL = `${window.location.origin}/api`;
  }

  ctx.$axios.onError(({ response }) => {
    const statusCode = parseInt(response && response.status, 10);

    if (statusCode >= 500) {
      const url = response.config.url.replace(response.config.baseURL, '');
      ctx.error({
        statusCode,
        message: {
          text: `ERP response ${statusCode} ${url}`,
          fingerprint: [url, statusCode],
        },
      });
    }
  });

  ctx.$axios.onRequest(req => {
    delete req.headers.common['content-length'];
  });

  ctx.$api = api;
  inject('api', api);
};
